// What the page's code takes from where it runs: the standalone site
// (js/site.js, index.html) or the store's Shopify theme (js/theme.js,
// shopify/sections/nothing-cross.liquid). Everything else is the same code.
// The page runs an environment module (js/site.js or js/theme.js), which sets
// it once, explicitly, then landing.js, which reads it, as two module scripts
// in that order (module scripts run in document order). Nothing detects where
// it runs.
//
// env: {
//   readOptions()  every option's value (js/options.js); throws on a bad one
//   connector      the commerce connector (js/shop/connector.js)
//   buyForm        what createBuyUI (js/shop/buy-ui.js) builds the buy
//                  control from: { formAction, variantId } (a new form), or
//                  { form } (a product form the server rendered)
//   drive          { name, capacity, photos }: the drive's label, its
//                  capacity label, and where its photos live (their folder,
//                  or their manifest's URL: js/drive/files.js, manifestUrl)
//   assetUrl(file) the URL of one of the scene's assets (js/cross-scene.js)
//   responses      { [file]: promise of its Response }: the page's own
//                  fetches of the scene's files (its models and the textures
//                  its first frame needs), started by an inline script
//                  before any module loads (createCrossScene's responses)
//   redesign       the redesigned page's content (page=redesign): null, the
//                  site's own (js/redesign/content.js); or { sections,
//                  stylesheets }, the theme's: its section's settings and
//                  blocks in content.js's shape, and the redesign's
//                  stylesheets' asset URLs
// }

const KEYS = ["readOptions", "connector", "buyForm", "drive", "assetUrl", "responses", "redesign"];

let env = null;

/** Sets the page's environment, once. */
export function setPageEnv(value) {
  if (env) throw new Error("page-env: the environment is already set");
  const keys = Object.keys(value).sort();
  if (keys.join() !== [...KEYS].sort().join()) {
    throw new Error(`page-env: expected exactly ${KEYS.join(", ")}; got ${keys.join(", ")}`);
  }
  env = Object.freeze({ ...value });
}

/** The page's environment; throws if no entry file has set it. */
export function pageEnv() {
  if (!env) throw new Error("page-env: no environment: run js/site.js or js/theme.js before landing.js");
  return env;
}
